<div class="card-actions" [style.top.px]="position" [ngStyle]="{ left: positionLeft + 'px' }">
    <ng-content></ng-content>
</div>
